// extracted by mini-css-extract-plugin
module.exports = {"icon":"LocaleSwitcher_icon__Y8fi8"};